module.exports = __webpack_public_path__ + "static/media/logoMealkit2.66d63e78.svg";